import throttle from 'lodash/throttle';
import { useEffect, useState } from 'react';

const getWindowScroll = (axis: 'x' | 'y') => {
  if (typeof window !== 'undefined') return axis === 'x' ? window.scrollX : window.scrollY;
  return 0;
};

const useWindowScroll = () => {
  const [isOnTop, setIsOnTop] = useState(getWindowScroll('y') === 0);

  useEffect(() => {
    const handleScroll = throttle(() => {
      setIsOnTop(getWindowScroll('y') === 0);
    }, 50);

    window.addEventListener('scroll', handleScroll);
    handleScroll();

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return { isOnTop };
};

export default useWindowScroll;
